/**
 * Dropzone Tour
 *
 * Walkthrough for the document classification and saving interface.
 * Every step anchors to real UI elements via data-tour attributes.
 */

import { TourDefinition } from '../config/tourSteps';

export const dropzoneTour: TourDefinition = {
  id: 'dropzoneTour',
  steps: [
    {
      element: '[data-tour="dropzone-summary"]',
      popover: {
        title: 'Overzicht',
        description:
          'Hier ziet u hoeveel Dropzone-mappen en bestanden gevonden zijn. Bestanden in _Dropzone mappen op SharePoint verschijnen automatisch.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="dropzone-actions"]',
      popover: {
        title: 'Acties',
        description:
          'Kies de AI-provider voor analyse, start een bulk AI-analyse voor alle bestanden, of verwerk DD-vragen op de achtergrond.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: '[data-tour="dropzone-results"]',
      popover: {
        title: 'Bestanden',
        description:
          'Alle bestanden gegroepeerd per maplocatie. Per bestand kunt u de AI-classificatie starten, het resultaat bekijken en het bestand opslaan.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: '[data-tour="dropzone-classify-button"]',
      popover: {
        title: 'AI Classificatie',
        description:
          'Klik hier om de AI het bestand te laten analyseren. De AI bepaalt het documenttype, extraheert metadata (datum, vervaldatum, status) en stelt een label voor.',
        side: 'left',
        align: 'center',
      },
    },
  ],
};
